<template>
    <div>
        <div class="col-left">
            <div v-for="(option, ndx) in dateFormatOptions" :key="option.value">
                <input type="radio" :id="'date-format-options' + ndx" name="date-format-options" :value="option.value" v-model="value.dateFormat" 
                    @change="updateDateFormat" />
                <label :for="'date-format-options' + ndx"><span style="color: var(--color-m)">{{option.value}}</span> 
                    <span style="color: var(--color-ms)">  ({{new Date() | moment(option.value) }}</span>)</label>
            </div>
        </div>
        <div class="col-right">
            <div v-for="(option, ndx) in timeFormatOptions" :key="option.value">
                <input type="radio" :id="'time-format-options' + ndx" name="time-format-options" :value="option.value" v-model="value.timeFormat"
                    @change="updateTimeFormat" />
                <label :for="'time-format-options' + ndx"><span style="color: var(--color-m)">{{option.value}}</span> 
                    <span style="color: var(--color-ms)">  ({{new Date() | moment(option.value) }}</span>)</label>
            </div>
        </div>
    </div>
</template>

<script>

const DateFormatOptions = [
    { value: "YYYY/MM/DD" },
    { value: "DD/MM/YYYY" },
    { value: "YYYY-MM-DD" },
    { value: "MM/DD/YYYY" },
    { value: "DD MMM YYYY" },
    { value: "DD/MM/YYY" },
    { value: "ddd, MMM Do YYYY" },
    { value: "MM.DD.YYYY" },
    { value: "MM/D/YYYY" },
    { value: "MM/DD/YYY" },
];

const TimeFormatOptions = [
    { value: "hh:mm a" },
    { value: "hh:mm" },
];

import vue from 'vue';
vue.use(require('vue-moment'));

export default {
    components: {
    },
    props: [ "value" ],
    data() {
        return {
            dateFormatOptions: DateFormatOptions,
            timeFormatOptions: TimeFormatOptions,
        }
    },
    methods: { 
        updateDateFormat($event) {
            this.$emit('update:dateFormat', $event.target.value);
        },
        updateTimeFormat($event) {
            this.$emit('update:timeFormat', $event.target.value);
        }
    },
    mounted() { 
    }
}
</script>

